import { IExecutionOptions } from '../models/query';
import { ConditionalHelper } from '../helpers/ConditionalHelper';
import { IQueryOptionsGlobalSearchContent } from '../models/query/options';
import { BaseCollectionQuery } from './BaseCollectionQuery';
import { Query } from './Query';
import { GlobalSearchArticle } from '../models/wordpressGlobalSearch';

export class WordpressGlobalSearchContentQuery extends BaseCollectionQuery<
	IQueryOptionsGlobalSearchContent
> {
	initialize(executionOptions: IExecutionOptions) { }
	getOptions(): IQueryOptionsGlobalSearchContent {
		const {
			code,
			key,
			collectionItemConditional,
			sort,
			options = {},
		} = this.queryOptions;
		return {
			code,
			key,
			collectionItemConditional,
			sort,
			...(options.wordpressGlobalSearch || {}),
		};
	}
	getRawValue<T = any>(executionOptions: IExecutionOptions): T {
		const { sort } = this.options;

		let posts = this.getPosts(executionOptions) as any;
		if (sort) {
			posts = this.applySort(
				posts,
				sort,
				undefined,
				executionOptions.inputs,
			);
		}
		return posts && posts.map(post => this.getPost(executionOptions, post));
	}
	getPosts(executionOptions: IExecutionOptions): GlobalSearchArticle[] {
		const conditionalHelper = new ConditionalHelper(
			{ conditions: [] },
			this.translationHelper,
		);
		const { collectionItemConditional = { conditions: [] } } = this.options;
		const context = Query.getContext(executionOptions, this.queryOptions);
		const { articles } = context.wordpressGlobalSearch;
		if (articles) {
			const collectionItems = articles.filter((item) => {
				return conditionalHelper.matches(
					item,
					collectionItemConditional,
					executionOptions,
				);
			});
			return collectionItems;
		}

		return;
	}
	getPost<T>(
		executionOptions: IExecutionOptions,
		post: GlobalSearchArticle,
	): T {
		const { code, key } = this.options;

		return this.getPostValue(executionOptions, post, code, key) as any;
	}
	getPostValue<T>(
		executionOptions: IExecutionOptions,
		post: GlobalSearchArticle,
		code: string = null,
		key: string = null,
	): T {
		if (post) {
			if (code && key) {
				const postMeta = post[code];
				const postMetaByKey = postMeta[key];
				if (postMetaByKey) {
					return postMetaByKey;
				}
			}
			if (code) {
				return post[code];
			}
		}
		return;
	}
}
